import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../abstraction/auth.service';
import { state, style, transition, animate, trigger, keyframes } from '@angular/animations';
import { IPromotionMessage } from '../../../models/PromotionMessage';

@Component({
  selector: 'app-promotion-messages-carousel',
  templateUrl: './promotion-messages-carousel.component.html',
  styleUrls: ['./promotion-messages-carousel.component.scss'],
  animations: [
    trigger('changeMessageTrigger', [
      state(
        'inactive',
        style({
          opacity: 0,
        }),
      ),
      state(
        'active',
        style({
          opacity: 1,
        }),
      ),
      transition('active <=> inactive', animate('900ms')),
    ]),
  ],
})
export class PromotionMessagesCarouselComponent implements OnInit, OnDestroy {
  constructor(private authService: AuthService) {}

  currentIndex = 0;
  messages: IPromotionMessage[] = [];
  intervalRef;
  waitTimeoutRef;

  ngOnInit(): void {
    this.authService.getPromotionMessage().subscribe((messages: IPromotionMessage[]) => {
      this.clearOldBanners(messages);
      this.messages = messages.filter(
        (message) => !localStorage.getItem(message.title + message.message),
      );

      this.startCarousel();
    });
  }

  nextMessage() {
    if (this.currentIndex === this.messages.length - 1) {
      this.currentIndex = 0;
      return;
    }
    this.currentIndex++;
  }

  previousMessage() {
    if (this.currentIndex === 0) {
      this.currentIndex = this.messages.length - 1;
      return;
    }
    this.currentIndex--;
  }

  startCarousel() {
    if (this.messages.length > 1) {
      this.waitTimeoutRef = setTimeout(() => {
        this.intervalRef = setInterval(() => {
          this.nextMessage();
        }, 6000);
      }, 1200);
    }
  }

  stopCarousel() {
    if (this.waitTimeoutRef) {
      clearTimeout(this.waitTimeoutRef);
      this.waitTimeoutRef = null;
    }

    if (this.intervalRef) {
      clearInterval(this.intervalRef);
      this.intervalRef = null;
    }
  }

  openLink(url: string) {
    window.location.href = url;
  }

  changeIndex(index: number) {
    this.stopCarousel();
    this.currentIndex = index;
  }

  closeBanner(index: number) {
    this.stopCarousel();
    localStorage.setItem(
      this.messages[index].title + this.messages[index].message,
      'banner-closed',
    );
    this.messages.splice(index, 1);
  }

  private clearOldBanners(messages: IPromotionMessage[]) {
    if (messages.length === 0) {
      return;
    }

    const storageValues = Object.entries(localStorage).filter(
      (value) => value[1] === 'banner-closed',
    );
    for (let value of storageValues) {
      const keyExist = messages.some((message) => message.title + message.message === value[0]);
      if (!keyExist) {
        localStorage.removeItem(value[0]);
      }
    }
  }

  ngOnDestroy(): void {
    this.stopCarousel();
  }
}
